"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FadePlate = void 0;
/**
 * Class description
 *
 * Created: 2019-07-31
 * @author jonas
 */
const gsap_1 = require("gsap");
class FadePlate extends PIXI.Container {
    get graphicsAlpha() {
        return this._graphicsAlpha;
    }
    set graphicsAlpha(value) {
        this._graphicsAlpha = value;
    }
    get graphicsColor() {
        return this._graphicsColor;
    }
    set graphicsColor(value) {
        this._graphicsColor = value;
    }
    constructor(graphicsColor = 0x000000, graphicsAlpha = 1, initState = 0) {
        super();
        this._graphicsColor = graphicsColor;
        this._graphicsAlpha = graphicsAlpha;
        this._graphics = new PIXI.Graphics();
        this.addChild(this._graphics);
        this.alpha = initState;
    }
    resize(x, y, width, height) {
        this._graphics.clear();
        this._graphics.beginFill(this._graphicsColor, this._graphicsAlpha);
        this._graphics.drawRect(0, 0, width, height);
        this._graphics.endFill();
        this.position.set(x, y);
    }
    getFadeIn(duration) {
        return new gsap_1.TweenLite(this, duration, { alpha: 1, ease: gsap_1.Linear.easeNone });
    }
    getFadeOut(duration) {
        return new gsap_1.TweenLite(this, duration, { alpha: 0, ease: gsap_1.Linear.easeNone });
    }
    getFadeTo(duration, alpha) {
        return new gsap_1.TweenLite(this, duration, { alpha: alpha, ease: gsap_1.Linear.easeNone });
    }
}
exports.FadePlate = FadePlate;
//# sourceMappingURL=FadePlate.js.map